import { render, staticRenderFns } from "./base-file-drop.vue?vue&type=template&id=95fe3478&scoped=true"
import script from "./base-file-drop.vue?vue&type=script&lang=js"
export * from "./base-file-drop.vue?vue&type=script&lang=js"
import style0 from "./base-file-drop.vue?vue&type=style&index=0&id=95fe3478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fe3478",
  null
  
)

export default component.exports